import { NgModule }                from '@angular/core';
import { FormsModule }             from '@angular/forms';
import { CommonModule }            from '@angular/common';
import { CaseManagementComponent } from './case-management.component';
import { CommonToolModule }        from '../common/common-tool.module';
import { NgxMyDatePickerModule }   from 'ngx-mydatepicker';
import { ScheduleModule }          from '../schedule/schedule.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgxMyDatePickerModule,
        ScheduleModule,
        CommonToolModule      //共通部品をcomponentとしてimportするとエラーになる、module化してimportする
    ],
    declarations: [
        CaseManagementComponent
    ],
    providers: [  ]
})
export class CaseModule {}



// WEBPACK FOOTER //
// ./src/app/case/case.module.ts